import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleV1Read } from '../models/module-v1-read.model';

@Injectable()
export class ModuleVersionService {
    constructor(private http: HttpClient) {}

    getModuleByVersionId(id: string): Observable<ModuleV1Read> {
        return this.http
            .get<ModuleV1Read>(`/api/module_manager/moduleversions/${id}`, { headers: { 'Content-Type': 'application/json' } })
            .pipe(map((module: ModuleV1Read) => new ModuleV1Read(module)));
    }
}
